import styled from "styled-components"

const ResetLI = styled.li`
margin:0;
padding:0;
border:0;
outline:0;
font-size:100%;
vertical-align:baseline;
background:transparent;
list-style:none;
`

export default ResetLI